module.exports = {
	"user": "ผู้ใช้งาน",
	"name": "ชื่อ-นามสกุล",
	"email": "อี-เมล",
	"role": "ตำแหน่ง",
	"view": "ผู้ใช้งานทั้งหมด",
	"create": "เพิ่มผู้ใช้งาน",
	"username": "ชื่อผู้ใช้",
	"deleteConfirmText": "ลบผู้ใช้งาน"
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/th/user.json
// module id = 840
// module chunks = 1